import {TAudiencesType} from "@/types/filterBlocks/audiencesTypeTypes";
import {TGeneralFilterBlock} from "@/types/filterBlocks/filterBlockTypes";
import {TTokenFilteringRules} from "./token/tokenFilteringRulesTypes";
import {TWalletWealthFilteringRules} from "./wallet/walletWealthFilteringRulesTypes";
import {TNftFilteringRules} from "./nft/nftFilteringRulesTypes";
import {TLastActivityFilteringRules} from "./activity/lastActivityFilteringRulesTypes";
import {TSpecificInteractionFilteringRules} from "./interaction/specificInteractionFilteringRulesTypes";
import {TCustomInteractionFilteringRules} from "./customInteraction/customInteractionFilteringRulesTypes";

export type TFiltrationAPIRequest = {
    user_id: string,
    query_id: string,
    niche: TAudiencesType,
    global_operator: 'or' | 'and',
    filtering_rules: TFiltrationFilteringRule[]
}

export type TFiltrationFilteringRule = {
    type: TFiltrationFilteringRuleType,
    values: TFiltrationFilteringRuleValue
}

export type TFiltrationFilteringRuleValue =
    TTokenFilteringRules
    | TWalletWealthFilteringRules
    | TNftFilteringRules
    | TLastActivityFilteringRules
    | TSpecificInteractionFilteringRules
    | TCustomInteractionFilteringRules

export type TFiltrationFilteringRuleType =
    'token_holdings'
    | 'wallet_wealth'
    | 'nft_holdings'
    | 'last_activity'
    | 'specific_interaction'
    | 'custom_interaction'

export const FiltrationTypes: Record<TGeneralFilterBlock, TFiltrationFilteringRuleType> = {
    token: 'token_holdings',
    wallet_wealth: 'wallet_wealth',
    nft: 'nft_holdings',
    last_activity: 'last_activity',
    interaction: 'specific_interaction',
    custom_interaction: 'custom_interaction'
}